import { render, staticRenderFns } from "./PoultrySuppliesHeader.vue?vue&type=template&id=dc962572&scoped=true"
import script from "./PoultrySuppliesHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PoultrySuppliesHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PoultrySuppliesHeader.vue?vue&type=style&index=0&id=dc962572&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc962572",
  null
  
)

export default component.exports